(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-contact"] && !Shopify.designMode) return;
  try {
    
const emailSelector = '[data-gp-email]';
const emailTargets = new Set();
const emailMeasurements = new WeakMap();
const fitEmail = (element) => {
  const width = element.clientWidth;
  if (width <= 1) return;
  const key = `${width}:${element.textContent}`;
  if (emailMeasurements.get(element) === key) return;
  element.style.setProperty('--gp-email-size', '13px');
  const range = document.createRange();
  range.selectNodeContents(element);
  const textWidth = range.getBoundingClientRect().width;
  const size = textWidth > width - 1 ? Math.floor(1300 * (width - 1) / textWidth) / 100 : 13;
  element.style.setProperty('--gp-email-size', `${size}px`);
  emailMeasurements.set(element, key);
};
const emailObserver = new ResizeObserver(entries => {
  for (const entry of entries) fitEmail(entry.target);
});
const refreshEmails = () => {
  for (const element of emailTargets) {
    if (!element.isConnected) {
      emailObserver.unobserve(element);
      emailTargets.delete(element);
    }
  }
  document.querySelectorAll(emailSelector).forEach(element => {
    if (!emailTargets.has(element)) {
      emailTargets.add(element);
      emailObserver.observe(element);
    }
    fitEmail(element);
  });
};
refreshEmails();
new MutationObserver(refreshEmails).observe(document.body, {subtree:true,childList:true,characterData:true});
document.addEventListener('toggle', event => {
  if (event.target.matches('.gp-contact__direct') && event.target.open) refreshEmails();
}, true);
document.addEventListener('shopify:section:load', refreshEmails);
if (document.fonts) document.fonts.ready.then(() => {
  emailTargets.forEach(element => emailMeasurements.delete(element));
  refreshEmails();
});
(() => {
  const successStyles = `
    [data-current-step="success"] [data-sizing="form-wrapper"] {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      background: transparent !important;
    }
    [data-current-step="success"] [data-testid="banner-success"] {
      box-sizing: border-box;
      width: 100%;
      padding: 14px 8px 22px;
      text-align: center !important;
      color: #e5e4e5;
    }
    [data-current-step="success"] [data-testid="banner-success"]::before {
      content: "";
      display: block;
      width: 92px;
      height: 92px;
      margin: 0 auto 22px;
      background: url("https://granpodergranada.com/cdn/shop/files/emblema_ancla_coronada_1x1_3fa55881-445c-4f09-9cf1-b3c13a938b6f.webp?v=1791440995&width=240") center / contain no-repeat;
      filter: drop-shadow(0 5px 16px #d9af6526);
    }
    [data-current-step="success"] [data-testid="banner-success"] h2 {
      display: block !important;
      width: 100%;
      margin: 0 0 20px !important;
      color: #f8f4ed !important;
      font: 400 36px/1.15 Georgia, "Times New Roman", serif !important;
      letter-spacing: -.02em !important;
      text-align: center !important;
      text-wrap: balance;
    }
    [data-current-step="success"] [data-testid="banner-success"] h2::after {
      content: "";
      display: block;
      width: 42px;
      height: 1px;
      margin: 20px auto 0;
      background: #d9af65;
    }
    [data-current-step="success"] [data-testid="banner-success"] p {
      max-width: 46ch;
      margin: 0 auto !important;
      color: #d8dadc !important;
      font-size: 16px !important;
      line-height: 1.75 !important;
      letter-spacing: 0 !important;
      text-align: center !important;
      text-wrap: pretty;
    }
    @media (max-width: 600px) {
      [data-current-step="success"] [data-testid="banner-success"] { padding: 12px 2px 14px; }
      [data-current-step="success"] [data-testid="banner-success"]::before { width: 76px; height: 76px; margin-bottom: 20px; }
      [data-current-step="success"] [data-testid="banner-success"] h2 { font-size: 30px !important; }
      [data-current-step="success"] [data-testid="banner-success"] p { font-size: 15px !important; line-height: 1.7 !important; }
    }
  `;
  const initializeConfirmation = () => {
    const section = document.getElementById('GpContact');
    if (!section) return;
    let attempts = 0;
    let timer;
    const attach = () => {
      const hosts = [...section.querySelectorAll('shopify-forms-embed')];
      for (const host of hosts) {
        const root = host.shadowRoot;
        if (!root || root.getElementById('gp-confirmation-style')) continue;
        const style = document.createElement('style');
        style.id = 'gp-confirmation-style';
        style.textContent = successStyles;
        root.appendChild(style);
      }
      const ready = hosts.length && hosts.every(host => host.shadowRoot?.getElementById('gp-confirmation-style'));
      if (ready || !section.isConnected || ++attempts >= 80) clearInterval(timer);
    };
    timer = setInterval(attach, 250);
    attach();
  };
  initializeConfirmation();
  document.addEventListener('shopify:section:load', initializeConfirmation);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
if (!window.gpNewsDisclosureReady) {
window.gpNewsDisclosureReady = true;
document.addEventListener('click', async function(event) {
  if (!(event.target instanceof Element)) return;
  let toggle = event.target.closest('.gp-blog [data-gp-toggle]');
  const collapsed = event.target.closest('.gp-blog [data-gp-article]:not(.is-open)');
  if (!toggle && collapsed && !event.target.closest('a,button,input,select,textarea,label,summary,[contenteditable="true"]') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && !window.getSelection()?.toString()) {
    toggle = collapsed.querySelector('[data-gp-toggle]');
  }
  const moreButton = event.target.closest('[data-gp-more-button]');
  const button = toggle || moreButton;
  if (!button) return;
  const root = button.closest('.gp-blog, [data-gp-news-root]');
  if (!root) return;
  if (toggle) {
    event.preventDefault();
    if (root.dataset.transitioning) return;
    const article = toggle.closest('[data-gp-article]');
    const opening = !article.classList.contains('is-open');
    const panel = article.querySelector('[data-gp-panel]');
    if (!panel) return;
    const setExpanded = (card, expanded) => {
      card.classList.toggle('is-open', expanded);
      card.querySelectorAll('[data-gp-toggle]').forEach(button => button.setAttribute('aria-expanded', String(expanded)));
      card.querySelector('[data-gp-panel]').hidden = !expanded;
    };
    const html = document.documentElement;
    const body = document.body;
    const anchor = html.style.overflowAnchor;
    const bodyAnchor = body.style.overflowAnchor;
    const scrollBehavior = html.style.scrollBehavior;
    html.style.overflowAnchor = 'none';
    body.style.overflowAnchor = 'none';
    html.style.scrollBehavior = 'auto';
    root.dataset.transitioning = 'true';
    const before = article.getBoundingClientRect();
    const initialScroll = window.scrollY;
    if (opening) {
      root.querySelectorAll('[data-gp-article].is-open').forEach(card => setExpanded(card, false));
    }
    // Measure the destination without painting it, then reveal from the top down.
    setExpanded(article, opening);
    const endHeight = article.getBoundingClientRect().height;
    if (!opening) setExpanded(article, true);
    article.dataset.gpResizing = '';
    article.style.setProperty('--gp-news-height', before.height + 'px');
    const topShift = article.getBoundingClientRect().top - before.top;
    const startScroll = initialScroll + topShift;
    window.scrollTo({top:startScroll, behavior:'instant'});
    const documentTop = article.getBoundingClientRect().top + window.scrollY;
    const header = document.querySelector('header.tb-header');
    const headerSpace = (header?.getBoundingClientRect().height || 60) + 16;
    const endScroll = opening ? startScroll : Math.min(startScroll, Math.max(0, documentTop - headerSpace));
    const finish = () => {
      setExpanded(article, opening);
      delete article.dataset.gpResizing;
      article.style.removeProperty('--gp-news-height');
      window.scrollTo({top:endScroll, behavior:'instant'});
      html.style.overflowAnchor = anchor;
      body.style.overflowAnchor = bodyAnchor;
      html.style.scrollBehavior = scrollBehavior;
      delete root.dataset.transitioning;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }
    const started = performance.now();
    const tick = now => {
      const progress = Math.min(1, (now - started) / 380);
      const eased = 1 - Math.pow(1 - progress, 3);
      article.style.setProperty('--gp-news-height', (before.height + (endHeight - before.height) * eased) + 'px');
      window.scrollTo({top:startScroll + (endScroll - startScroll) * eased, behavior:'instant'});
      if (progress < 1) requestAnimationFrame(tick);
      else finish();
    };
    requestAnimationFrame(tick);
    return;
  }
  if (moreButton.disabled) return;
  moreButton.disabled = true;
  const list = root.querySelector('.gp-news-list');
  try {
    let pending = Array.from(list.querySelectorAll('[data-gp-more][hidden]'));
    if (pending.length < 4 && moreButton.dataset.nextUrl) {
      const url = new URL(moreButton.dataset.nextUrl, window.location.href);
      url.searchParams.set('section_id', moreButton.dataset.sectionId);
      const response = await fetch(url);
      if (!response.ok) throw new Error('Unable to load articles');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextList = doc.querySelector('.gp-news-list');
      if (!nextList) throw new Error('Missing articles');
      nextList.querySelectorAll('[data-gp-article]').forEach(function(row) {
        row.setAttribute('data-gp-more', '');
        row.hidden = true;
        list.appendChild(row);
      });
      moreButton.dataset.nextUrl = doc.querySelector('[data-gp-more-button]')?.dataset.nextUrl || '';
      pending = Array.from(list.querySelectorAll('[data-gp-more][hidden]'));
    }
    const batch = pending.slice(0, 4);
    batch.forEach(function(row) { row.hidden = false; });
    moreButton.querySelector('span').textContent = moreButton.dataset.label;
    if (!list.querySelector('[data-gp-more][hidden]') && !moreButton.dataset.nextUrl) {
      moreButton.closest('.gp-load-more').hidden = true;
    }
    batch[0]?.querySelector('.gp-entry-title')?.focus();
  } catch (error) {
    moreButton.querySelector('span').textContent = moreButton.dataset.error;
  } finally {
    moreButton.disabled = false;
  }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sones-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input', function(event) { if (!event.target.matches('.se-search input')) return; const site = event.target.closest('.se-site'); const query = event.target.value.trim().toLocaleLowerCase(); const active = site.querySelector('.se-filters [aria-pressed="true"]'); const type = active ? active.dataset.seFilter : 'all'; let visible = 0; site.querySelectorAll('[data-se-item]').forEach(function(item) { const matches = item.dataset.search.includes(query) && (type === 'all' || item.dataset.type === type); item.hidden = !matches; if (matches) visible += 1; }); const empty = site.querySelector('.se-empty'); if (empty) empty.hidden = visible !== 0; });
document.addEventListener('click', function(event) { const button = event.target.closest('[data-se-filter]'); if (!button) return; const site = button.closest('.se-site'); site.querySelectorAll('[data-se-filter]').forEach(function(filter) { filter.setAttribute('aria-pressed', filter === button ? 'true' : 'false'); }); const search = site.querySelector('.se-search input'); if (search) search.dispatchEvent(new Event('input', { bubbles: true })); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taku-band"] && !Shopify.designMode) return;
  try {
    
(() => {
  const extendArchive = () => {
    const list = document.querySelector('.gp-accompaniment-archive > .gp-timeline');
    if (!list) return;
    list.querySelectorAll('[data-gp-extension-card]').forEach(card => card.remove());
    document.querySelectorAll('template[data-gp-archive-extension]').forEach(template => {
      const content = template.content.cloneNode(true);
      content.querySelectorAll('li').forEach(card => {
        card.dataset.gpExtensionCard = template.dataset.gpArchiveExtension;
        const disclosure = card.querySelector('details');
        if (disclosure) disclosure.name = 'gp-accompaniment-archive';
      });
      list.append(content);
    });
    Array.from(list.children).sort((a,b) => (Number(a.dataset.gpArchiveOrder) || Infinity) - (Number(b.dataset.gpArchiveOrder) || Infinity)).forEach(card => list.append(card));
  };
  const initialise = root => {
    root.querySelectorAll('.gp-reference').forEach(reference => {
      if (reference.dataset.initialised) return;
      reference.dataset.initialised = 'true';
      const panels = Array.from(reference.querySelectorAll('[data-gp-panel]'));
      const links = Array.from(reference.querySelectorAll('[data-gp-tab]'));
      const activate = name => {
        panels.forEach(panel => { panel.hidden = panel.dataset.gpPanel !== name; });
        links.forEach(link => {
          if (link.dataset.gpTab === name) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        activate(link.dataset.gpTab);
        if (link.classList.contains('gp-history-cta')) reference.querySelector('.gp-memory-nav').scrollIntoView({block:'start', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      reference.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-gp-panel]');
        if (panel) activate(panel.dataset.gpPanel);
        const disclosure = event.target.querySelector('details');
        if (disclosure) disclosure.open = true;
      });
      const requested = panels.find(panel => '#' + panel.id === window.location.hash);
      activate(requested ? requested.dataset.gpPanel : 'timeline');
    });
  };
  initialise(document);
  extendArchive();
  document.addEventListener('shopify:section:load', event => { initialise(event.target); extendArchive(); });
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(extendArchive));
  document.addEventListener('shopify:block:select', event => {
    const blockId = event.detail && event.detail.blockId;
    if (!blockId) return;
    const card = Array.from(document.querySelectorAll('.gp-accompaniment-archive [data-shopify-editor-block]')).find(element => {
      try { return JSON.parse(element.getAttribute('data-shopify-editor-block')).id === blockId; } catch (_) { return false; }
    });
    if (!card) return;
    const reference = card.closest('.gp-reference');
    const link = reference && reference.querySelector('[data-gp-tab="accompaniments"]');
    if (link) link.click();
    const disclosure = card.querySelector('details');
    if (disclosure) disclosure.open = true;
    card.scrollIntoView({block:'center',behavior:'instant'});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taku-editable-repertoire"] && !Shopify.designMode) return;
  try {
    

(() => {
  let filter = 'all';
  let expanded = false;
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

  const comingMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function animateComingWord(word) {
    const letters = Array.from(word.querySelectorAll('.gp-repertoire__coming-letter'));
    const stagger = 40;
    const reveal = 260;
    const complete = 140 + (letters.length - 1) * stagger + reveal;
    const fadeStart = complete + 1000;
    const fadeEnd = fadeStart + 420;
    const duration = fadeEnd + 300;
    const startTime = document.timeline.currentTime;
    letters.forEach((letter, index) => {
      letter.getAnimations().forEach(animation => animation.cancel());
      if (comingMotion.matches || !letter.animate) return;
      const start = 140 + index * stagger;
      const animation = letter.animate([
        { opacity: 0, transform: 'translateY(2px)', textShadow: '0 0 0px transparent', offset: 0 },
        { opacity: 0, transform: 'translateY(2px)', textShadow: '0 0 0px transparent', offset: start / duration, easing: 'ease-out' },
        { opacity: 1, transform: 'translateY(0px)', textShadow: '0 0 6px #f6dc9c, 0 0 16px rgba(229,197,121,.7)', offset: (start + reveal) / duration, easing: 'ease-out' },
        { opacity: 1, transform: 'translateY(0px)', textShadow: '0 0 4px rgba(229,197,121,.4)', offset: fadeStart / duration, easing: 'ease-in-out' },
        { opacity: 0, transform: 'translateY(0px)', textShadow: '0 0 0px transparent', offset: fadeEnd / duration },
        { opacity: 0, transform: 'translateY(2px)', textShadow: '0 0 0px transparent', offset: 1 }
      ], { duration, iterations: Infinity, fill: 'both' });
      animation.startTime = startTime;
    });
  }
  function prepareComingSoon() {
    document.querySelectorAll('[data-gp-section] h3').forEach(heading => {
      if (heading.dataset.gpComingReady) return;
      heading.dataset.gpComingReady = 'true';
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const text = node.textContent;
        const matches = Array.from(text.matchAll(/próximamente/gi));
        if (!matches.length) return;
        const fragment = document.createDocumentFragment();
        let previous = 0;
        matches.forEach(match => {
          fragment.append(document.createTextNode(text.slice(previous, match.index)));
          const word = document.createElement('span');
          word.className = 'gp-repertoire__coming';
          const accessible = document.createElement('span');
          accessible.className = 'gp-visually-hidden';
          accessible.textContent = match[0];
          word.append(accessible);
          const visual = document.createElement('span');
          visual.setAttribute('aria-hidden', 'true');
          Array.from(match[0]).forEach(character => {
            const letter = document.createElement('span');
            letter.className = 'gp-repertoire__coming-letter';
            letter.textContent = character;
            visual.append(letter);
          });
          word.append(visual);
          fragment.append(word);
          previous = match.index + match[0].length;
        });
        fragment.append(document.createTextNode(text.slice(previous)));
        node.replaceWith(fragment);
      });
      heading.querySelectorAll('.gp-repertoire__coming').forEach(animateComingWord);
    });
  }
  comingMotion.addEventListener('change', () => {
    document.querySelectorAll('.gp-repertoire__coming').forEach(animateComingWord);
  });
  const rows = () => Array.from(document.querySelectorAll('[data-gp-section] .gp-repertoire__march'));
  const isConcealed = row => row.dataset.gpConcealed === 'true';
  const collator = new Intl.Collator('es', {sensitivity:'base',numeric:true});
  function restoreRowOwners() {
    const sections = Array.from(document.querySelectorAll('[data-gp-source-section]'));
    rows().forEach(row => {
      const owner = sections.find(section => section.dataset.gpSourceSection === row.dataset.gpOwner);
      owner?.querySelector('[data-gp-catalog-list]')?.append(row);
    });
    document.querySelectorAll('[data-gp-concealed-group]').forEach(group => group.remove());
  }
  function organizeRows() {
    restoreRowOwners();
    const allRows = rows();
    const first = document.querySelector('[data-gp-source-section]');
    const catalog = first?.querySelector('[data-gp-catalog-list]');
    if (!catalog) return;
    const concealed = document.createElement('section');
    concealed.className = 'gp-repertoire__concealed-group';
    concealed.dataset.gpConcealedGroup = '';
    const title = document.createElement('h2');
    title.textContent = first.dataset.gpConcealedLabel || 'Próximamente';
    const list = document.createElement('ol');
    list.className = 'gp-repertoire__list';
    list.setAttribute('aria-label', title.textContent);
    concealed.append(title,list);
    catalog.after(concealed);
    allRows.filter(isConcealed).forEach(row => list.append(row));
    allRows.filter(row => !isConcealed(row)).sort((a,b) => collator.compare(a.querySelector('h3')?.textContent || '',b.querySelector('h3')?.textContent || '')).forEach(row => catalog.append(row));
  }
  const group = row => {
    if (!row.hasAttribute('data-gp-category')) return 'concealed';
    const category = normalize(row.dataset.gpCategory || '');
    if (category === 'ordinario') return 'ordinary';
    if (['clasica', 'clasico', 'clasicas', 'clasicos'].includes(category)) return 'classic';
    if (['propia', 'propio', 'propias', 'propios'].includes(category)) return 'own';
    return 'other';
  };
  function resetAudio(audio) {
    const row = audio.closest('.gp-repertoire__march');
    const button = row && row.querySelector('[data-gp-play]');
    if (button) {
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Reproducir fragmento de ' + button.dataset.title);
    }
  }
  const audioPreviews = new WeakMap();
  let previewContext;
  function pausePreview(audio) {
    const preview = audioPreviews.get(audio);
    if (preview) preview.pause(); else audio.pause();
  }
  function bindAudioPreview(audio) {
    const start = Math.max(0, Number(audio.dataset.gpStart) || 0);
    const end = start + Math.min(40, Math.max(5, Number(audio.dataset.gpLength) || 40));
    let timer, volumeTimer, pauseTimer, gain;
    let stopping = false;
    const clear = () => { clearTimeout(timer); clearTimeout(volumeTimer); };
    const level = () => gain ? gain.gain.value : audio.volume;
    const setLevel = value => {
      if (gain) {
        const now = previewContext.currentTime;
        gain.gain.cancelScheduledValues(now);
        gain.gain.setValueAtTime(value, now);
      } else audio.volume = value;
    };
    const stop = () => {
      clear();
      clearTimeout(pauseTimer);
      stopping = false;
      setLevel(0);
      audio.pause();
      audio.currentTime = start;
      resetAudio(audio);
    };
    const check = () => {
      clearTimeout(timer);
      if (audio.paused) return;
      if (Number.isFinite(audio.duration) && start >= audio.duration) { stop(); return; }
      const limit = Math.min(end, Number.isFinite(audio.duration) ? audio.duration : end);
      if (audio.currentTime >= limit || audio.ended) { stop(); return; }
      if (audio.currentTime < start) audio.currentTime = start;
      const remaining = (limit - audio.currentTime) / (audio.playbackRate || 1);
      timer = setTimeout(check, Math.max(10, Math.min(500, remaining * 1000)));
    };
    const envelope = () => {
      if (audio.paused || stopping) return;
      clearTimeout(volumeTimer);
      const position = Math.max(start, audio.currentTime);
      const limit = Math.min(end, Number.isFinite(audio.duration) ? audio.duration : end);
      const rate = audio.playbackRate || 1;
      const remaining = Math.max(0, (limit - position) / rate);
      const fadeIn = Math.min(0.7, remaining / 2);
      const fadeOut = Math.min(1.2, remaining / 2);
      setLevel(0);
      if (!remaining) { stop(); return; }
      if (gain) {
        const now = previewContext.currentTime;
        gain.gain.linearRampToValueAtTime(1, now + fadeIn);
        gain.gain.setValueAtTime(1, now + remaining - fadeOut);
        gain.gain.linearRampToValueAtTime(0, now + remaining);
      } else {
        const tick = () => {
          if (audio.paused || stopping) return;
          const elapsed = Math.max(0, (audio.currentTime - position) / rate);
          audio.volume = Math.max(0, Math.min(1, elapsed / fadeIn, (remaining - elapsed) / fadeOut));
          volumeTimer = setTimeout(tick, 25);
        };
        tick();
      }
      check();
    };
    audioPreviews.set(audio, {
      async prepare() {
        clearTimeout(pauseTimer);
        stopping = false;
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        const sourceUrl = new URL(audio.currentSrc || audio.src, window.location.href);
        const canUseGain = sourceUrl.origin === window.location.origin || sourceUrl.hostname === 'cdn.shopify.com';
        if (!gain && AudioContextClass && canUseGain) {
          previewContext = previewContext || new AudioContextClass();
          gain = previewContext.createGain();
          previewContext.createMediaElementSource(audio).connect(gain);
          gain.connect(previewContext.destination);
        }
        setLevel(0);
        if (gain && previewContext.state === 'suspended') await previewContext.resume();
      },
      pause() {
        if (audio.paused || stopping) return;
        stopping = true;
        clear();
        const from = level();
        setLevel(from);
        if (gain) gain.gain.linearRampToValueAtTime(0, previewContext.currentTime + 0.25);
        else {
          const beginning = performance.now();
          const tick = () => {
            audio.volume = Math.max(0, from * (1 - (performance.now() - beginning) / 250));
            volumeTimer = setTimeout(tick, 20);
          };
          tick();
        }
        pauseTimer = setTimeout(() => {
          clear();
          setLevel(0);
          audio.pause();
          stopping = false;
        }, 250);
      }
    });
    audio.addEventListener('loadedmetadata', () => {
      if (Number.isFinite(audio.duration) && start >= audio.duration) {
        stop();
        const error = audio.closest('.gp-repertoire__march').querySelector('.gp-repertoire__audio-error');
        error.textContent = 'El inicio del fragmento supera la duración del audio. Ajusta el segundo de inicio.';
        error.hidden = false;
        return;
      }
      if (audio.currentTime < start || audio.currentTime >= end) audio.currentTime = start;
    });
    ['playing', 'seeked', 'ratechange'].forEach(name => audio.addEventListener(name, envelope));
    audio.addEventListener('timeupdate', check);
    ['pause', 'waiting', 'stalled', 'error', 'emptied'].forEach(name => audio.addEventListener(name, () => {
      clear();
      clearTimeout(pauseTimer);
      stopping = false;
      setLevel(0);
    }));
    audio.addEventListener('ended', stop);
  }
  function refresh() {
    const tools = document.querySelector('[data-gp-tools]');
    if (!tools) return;
    const allRows = rows();
    const query = normalize(tools.querySelector('[data-gp-search]').value);
    const matches = allRows.filter(row => {
      const category = normalize(row.dataset.gpCategory || '');
      const text = normalize((row.querySelector('h3')?.textContent || row.querySelector('.gp-repertoire__alternative')?.textContent || '') + ' ' + (row.querySelector('.gp-repertoire__composer')?.textContent || '') + ' ' + category + ' ' + normalize(row.dataset.gpFormation || ''));
      return (!query || text.includes(query)) && (filter === 'all' || group(row) === filter);
    });
    const compact = tools.dataset.compact === 'true' && !expanded && !query && filter === 'all';
    const regularMatches = matches.filter(row => !isConcealed(row));
    const visible = new Set(compact ? [...matches.filter(isConcealed),...regularMatches.slice(0, 6)] : matches);
    let visibleIndex = 0;
    allRows.forEach(row => {
      row.hidden = !visible.has(row);
      row.classList.toggle('gp-repertoire__march--group-start', !row.hidden && !isConcealed(row) && visibleIndex > 0 && visibleIndex % 5 === 0);
      if (row.hidden) row.querySelectorAll('audio').forEach(audio => pausePreview(audio));
      else if (!isConcealed(row)) visibleIndex += 1;
    });
    const concealedGroup = document.querySelector('[data-gp-concealed-group]');
    if (concealedGroup) concealedGroup.hidden = !matches.some(isConcealed);
    tools.querySelector('[data-gp-count]').textContent = matches.length + (matches.length === 1 ? ' composición' : ' composiciones') + (query || filter !== 'all' ? ' de ' + allRows.length : '');
    tools.querySelector('[data-gp-empty]').hidden = matches.length > 0;
    tools.querySelectorAll('[data-gp-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gpFilter === filter)));
    document.querySelectorAll('[data-gp-editorial]').forEach(el => { el.hidden = compact; });
    const more = document.querySelector('[data-gp-expand]');
    if (more) {
      more.hidden = tools.dataset.compact !== 'true' || !!query || filter !== 'all' || regularMatches.length <= 6;
      more.textContent = expanded ? 'Mostrar menos ↑' : 'Ver repertorio completo →';
      more.setAttribute('aria-expanded', String(expanded));
    }
  }
  function init() {
    organizeRows();
    prepareComingSoon();
    const tools = document.querySelector('[data-gp-tools]');
    const allRows = rows();
    let next = 1;
    document.querySelectorAll('.gp-repertoire__list').forEach(list => { list.start = next; next += list.children.length; });
    document.querySelectorAll('[data-gp-play]').forEach(button => {
      const audio = button.parentElement.querySelector('audio');
      button.hidden = false;
      audio.hidden = true;
      audio.controls = false;
      if (!audio.dataset.gpBound) {
        audio.dataset.gpBound = 'true';
        bindAudioPreview(audio);
        ['pause', 'ended', 'error'].forEach(event => audio.addEventListener(event, () => resetAudio(audio)));
        audio.addEventListener('play', () => {
          document.querySelectorAll('[data-gp-section] audio').forEach(other => { if (other !== audio) pausePreview(other); });
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Pausar fragmento de ' + button.dataset.title);
        });
      }
    });
    if (!tools) return;
    tools.hidden = false;
    const filterBox = tools.querySelector('[data-gp-filters]');
    if (!['all', 'classic', 'own', 'other', 'ordinary'].includes(filter)) filter = 'all';
    filterBox.replaceChildren();
    [['all', 'Todas'], ['classic', 'Clásica'], ['own', 'Propias'], ['other', 'Otras formaciones'], ['ordinary', tools.closest('[data-gp-section]').dataset.gpOrdinaryLabel]].forEach(([value, label]) => {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.gpFilter = value; button.textContent = label;
      filterBox.appendChild(button);
    });
    document.querySelectorAll('[data-gp-more-slot]').forEach(slot => slot.replaceChildren());
    const slots = document.querySelectorAll('[data-gp-more-slot]');
    if (slots.length) {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.gpExpand = ''; slots[slots.length - 1].appendChild(button);
    }
    refresh();
  }
  document.addEventListener('input', event => { if (event.target.matches('[data-gp-search]')) refresh(); });
  document.addEventListener('click', async event => {
    const target = event.target.closest('[data-gp-filter], [data-gp-expand], [data-gp-play]');
    if (!target) return;
    if (target.hasAttribute('data-gp-filter')) { filter = target.dataset.gpFilter; refresh(); return; }
    if (target.hasAttribute('data-gp-expand')) { expanded = !expanded; refresh(); return; }
    event.preventDefault();
    const row = target.closest('.gp-repertoire__march');
    const audio = row.querySelector('audio');
    const error = row.querySelector('.gp-repertoire__audio-error');
    if (!audio.paused) { pausePreview(audio); return; }
    error.hidden = true;
    document.querySelectorAll('[data-gp-section] audio').forEach(other => { if (other !== audio) pausePreview(other); });
    const start = Math.max(0, Number(audio.dataset.gpStart) || 0);
    const length = Math.min(40, Math.max(5, Number(audio.dataset.gpLength) || 40));
    if (audio.ended || audio.currentTime < start || audio.currentTime >= start + length) audio.currentTime = start;
    try { await audioPreviews.get(audio).prepare(); await audio.play(); }
    catch (e) { if (e.name !== 'AbortError') { resetAudio(audio); error.hidden = false; } }
  });
  document.addEventListener('shopify:block:select', event => {
    if (event.target.closest('[data-gp-section]')) { expanded = true; const selectedRow = event.target.closest('.gp-repertoire__march') || event.target.querySelector('.gp-repertoire__march'); filter = selectedRow && group(selectedRow) === 'ordinary' ? 'ordinary' : 'all'; const input = document.querySelector('[data-gp-search]'); if (input) input.value = ''; refresh(); }
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-gp-source-section]')) restoreRowOwners();
  });
  document.addEventListener('shopify:section:load', event => {
    const section = event.target.querySelector('[data-gp-source-section]');
    if (section) {
      rows().filter(row => row.dataset.gpOwner === section.dataset.gpSourceSection && !section.contains(row)).forEach(row => row.remove());
      init();
    }
  });
  document.addEventListener('shopify:section:reorder', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taku-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root) {
    if (controllers.has(root)) return;
    const slides = Array.from(root.querySelectorAll('[data-tbh-slide]'));
    const titles = slides.map(slide => slide.querySelector('h1')).filter(Boolean);
    const timers = new Map();
    let interval;
    let frame;
    let shownIndex = -1;
    titles.forEach(title => {
      const content = title.textContent;
      title.setAttribute('aria-label', content);
      const wrapper = document.createElement('span');
      wrapper.dataset.tbhFit = '';
      wrapper.setAttribute('aria-hidden', 'true');
      const letters = typeof Intl.Segmenter === 'function'
        ? Array.from(new Intl.Segmenter('es', {granularity: 'grapheme'}).segment(content), part => part.segment)
        : Array.from(content);
      const count = letters.filter(letter => !/\s/.test(letter)).length;
      const stagger = Math.min(22, 490 / Math.max(1, count - 1));
      let index = 0;
      letters.forEach(letter => {
        if (/\s/.test(letter)) {
          wrapper.append(document.createTextNode(letter));
          return;
        }
        const span = document.createElement('span');
        span.className = 'tbh__letter';
        span.style.setProperty('--tbh-delay', `${index++ * stagger}ms`);
        span.textContent = letter;
        wrapper.append(span);
      });
      title.replaceChildren(wrapper);
    });
    function fitTitles() {
      titles.forEach(title => {
        const text = title.querySelector('[data-tbh-fit]');
        title.style.setProperty('font-size', 'clamp(24px,3.4vw,34px)', 'important');
        const base = parseFloat(getComputedStyle(title).fontSize) || 30;
        const width = title.clientWidth;
        const natural = text.getBoundingClientRect().width;
        if (width && natural) title.style.setProperty('font-size', `${Math.max(14, Math.min(220, base * width / natural * .97))}px`, 'important');
      });
    }
    function scheduleFit() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fitTitles);
    }
    function reveal(slide) {
      const title = slide?.querySelector('h1');
      if (!title) return;
      clearTimeout(timers.get(title));
      title.classList.remove('is-revealing');
      if (reducedMotion.matches) return;
      void title.offsetWidth;
      title.classList.add('is-revealing');
      const timer = setTimeout(() => {
        title.classList.remove('is-revealing');
        timers.delete(title);
      }, 900);
      timers.set(title, timer);
    }
    function show(index) {
      if (shownIndex === index) {
        fitTitles();
        return;
      }
      shownIndex = index;
      slides.forEach((slide, position) => {
        slide.classList.toggle('is-active', position === index);
        slide.setAttribute('aria-hidden', position === index ? 'false' : 'true');
      });
      fitTitles();
      reveal(slides[index]);
    }
    function resume() {
      clearInterval(interval);
      if (slides.length < 2) return;
      interval = setInterval(() => {
        const active = slides.findIndex(slide => slide.classList.contains('is-active'));
        show((Math.max(0, active) + 1) % slides.length);
      }, Math.max(3, Number(root.dataset.interval) || 5) * 1000);
    }
    const observer = new ResizeObserver(scheduleFit);
    observer.observe(root.querySelector('.tbh__slides') || root);
    controllers.set(root, {
      select(slide) {
        clearInterval(interval);
        const index = slides.indexOf(slide);
        if (index >= 0) show(index);
      },
      resume,
      destroy() {
        clearInterval(interval);
        cancelAnimationFrame(frame);
        timers.forEach(clearTimeout);
        observer.disconnect();
        controllers.delete(root);
      }
    });
    show(Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active'))));
    resume();
    if (document.fonts?.ready) document.fonts.ready.then(() => {
      if (root.isConnected) scheduleFit();
    });
  }
  function initializeAll(scope = document) {
    if (scope.matches?.('[data-tbh]')) initialize(scope);
    scope.querySelectorAll('[data-tbh]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), {once: true});
  else initializeAll();
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tbh]').forEach(root => controllers.get(root)?.destroy());
  });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-tbh-slide]');
    if (slide) controllers.get(slide.closest('[data-tbh]'))?.select(slide);
  });
  document.addEventListener('shopify:block:deselect', event => {
    const root = event.target.closest('[data-tbh]');
    if (root) controllers.get(root)?.resume();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taku-news"] && !Shopify.designMode) return;
  try {
    
if (!window.gpHomeNewsMotionReady) {
  window.gpHomeNewsMotionReady = true;
  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-gp-toggle]');
    const root = toggle?.closest('[data-gp-news-root]');
    if (!root) return;
    // Home cards have their own vertical disclosure animation.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (root.dataset.transitioning) return;
    const article = toggle.closest('[data-gp-article]');
    const opening = !article.classList.contains('is-open');
    const panel = article.querySelector('[data-gp-panel]');
    if (!panel) return;
    const setExpanded = (card, expanded) => {
      card.classList.toggle('is-open', expanded);
      card.querySelectorAll('[data-gp-toggle]').forEach(button => button.setAttribute('aria-expanded', String(expanded)));
      card.querySelector('[data-gp-panel]').hidden = !expanded;
    };
    const html = document.documentElement;
    const body = document.body;
    const anchor = html.style.overflowAnchor;
    const bodyAnchor = body.style.overflowAnchor;
    const scrollBehavior = html.style.scrollBehavior;
    html.style.overflowAnchor = 'none';
    body.style.overflowAnchor = 'none';
    html.style.scrollBehavior = 'auto';
    root.dataset.transitioning = 'true';
    const before = article.getBoundingClientRect();
    const initialScroll = window.scrollY;
    if (opening) {
      root.querySelectorAll('[data-gp-article].is-open').forEach(card => setExpanded(card, false));
    }
    // Measure the destination without painting it, then reveal from the top down.
    setExpanded(article, opening);
    const endHeight = article.getBoundingClientRect().height;
    if (!opening) setExpanded(article, true);
    article.dataset.gpResizing = '';
    article.style.setProperty('--gp-news-height', before.height + 'px');
    const topShift = article.getBoundingClientRect().top - before.top;
    const startScroll = initialScroll + topShift;
    window.scrollTo({top:startScroll, behavior:'instant'});
    const documentTop = article.getBoundingClientRect().top + window.scrollY;
    const header = document.querySelector('header.tb-header');
    const headerSpace = (header?.getBoundingClientRect().height || 60) + 16;
    const endScroll = opening ? startScroll : Math.min(startScroll, Math.max(0, documentTop - headerSpace));
    const finish = () => {
      setExpanded(article, opening);
      delete article.dataset.gpResizing;
      article.style.removeProperty('--gp-news-height');
      window.scrollTo({top:endScroll, behavior:'instant'});
      html.style.overflowAnchor = anchor;
      body.style.overflowAnchor = bodyAnchor;
      html.style.scrollBehavior = scrollBehavior;
      delete root.dataset.transitioning;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }
    const started = performance.now();
    const tick = now => {
      const progress = Math.min(1, (now - started) / 380);
      const eased = 1 - Math.pow(1 - progress, 3);
      article.style.setProperty('--gp-news-height', (before.height + (endHeight - before.height) * eased) + 'px');
      window.scrollTo({top:startScroll + (endScroll - startScroll) * eased, behavior:'instant'});
      if (progress < 1) requestAnimationFrame(tick);
      else finish();
    };
    requestAnimationFrame(tick);
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taku-reservas-collection"]) return;
  try {
    
if (!customElements.get('gp-reservas')) {
  customElements.define('gp-reservas', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-availability]')?.addEventListener('change', (event) => {
        let count = 0;
        this.querySelectorAll('[data-available]').forEach((card) => {
          card.hidden = event.target.value !== 'all' && card.dataset.available !== event.target.value;
          if (!card.hidden) count++;
        });
        this.querySelector('.gpr-filter-empty').hidden = count > 0;
      });
      this.querySelector('[data-sort]')?.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
